import { useQuery } from '@tanstack/react-query';
import { Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';

import { CartProvider } from '@/components/cart-provider';
import { NewVersion } from '@/components/new-version';
import { identifySentryUser } from '@/lib/sentry';
import { meQuery } from '@/queries';

/**
 * What Next's app/layout.tsx did, minus the parts that were framework
 * plumbing. <html>/<body>, the font link and the theme script now live in
 * index.html, where they belong in a Vite app and where they cost nothing to
 * render.
 */
export function RootLayout() {
  // Who an error happened to, by id and role only.
  //
  // `useQuery`, NOT `useSuspenseQuery`. This sits above every route, and
  // suspending here would hold the WHOLE application on one request. Monitoring
  // must never be able to delay the thing it is monitoring.
  const me = useQuery(meQuery).data;
  useEffect(() => {
    identifySentryUser(me?.user?.id ?? null, me?.user?.role ?? null);
  }, [me?.user?.id, me?.user?.role]);

  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-[10px] focus:bg-panel focus:px-4 focus:py-3 focus:font-semibold focus:shadow-[var(--shadow-lift)]"
      >
        Skip to content
      </a>
      <CartProvider>
        <Outlet />
      </CartProvider>
      {/* At the ROOT, so a tab left open on any screen is told, not only one
          left open on the dashboard. */}
      <NewVersion />
    </>
  );
}
